import * as XLSX from 'xlsx';
import { numberToCurrency } from 'vqp-common';
import { PRODUCT_STATUS } from '../constants/product';

const formatPrice = (value) => {
  if (value == null || value === '' || Number.isNaN(Number(value))) return '—';
  return numberToCurrency(Number(value));
};

/**
 * Gera e faz download de um relatório Excel do cardápio.
 * @param {Array} categories - Lista de categorias com produtos (formato do reducer/API)
 * @param {Array} detailGroups - Lista de grupos de detalhes/acompanhamentos (opcional)
 * @param {string} fileName - Nome do arquivo sem extensão (default: relatorio-cardapio)
 */
export const exportMenuReport = (categories, detailGroups = [], fileName = 'relatorio-cardapio') => {
  const wb = XLSX.utils.book_new();

  // --- Aba: Categorias e Produtos ---
  const productRows = [];
  const productHeaders = [
    'Id',
    'Categoria',
    'Ordem Categoria',
    'Código',
    'Nome do Produto',
    'Status',
    'Preço',
    'Preço Delivery',
  ];
  (categories || []).forEach((cat) => {
    (cat.products || []).forEach((prod) => {
      const statusLabel = prod.status === PRODUCT_STATUS.ACTIVE ? 'Ativo' : 'Inativo';
      productRows.push({
        'Id': prod.id ?? '—',
        'Categoria': cat.name ?? '—',
        'Ordem Categoria': cat.order != null ? cat.order : '—',
        'Código': prod.code ?? '—',
        'Nome do Produto': prod.name ?? '—',
        'Status': statusLabel,
        'Preço': formatPrice(prod.price),
        'Preço Delivery': formatPrice(prod.priceDelivery),
      });
    });
  });
  const sheetProducts = XLSX.utils.json_to_sheet(
    productRows.length ? productRows : [{ 'Id': '', 'Categoria': '', 'Ordem Categoria': '', 'Código': '', 'Nome do Produto': '', 'Status': '', 'Preço': '', 'Preço Delivery': '' }],
    { header: productHeaders }
  );
  XLSX.utils.book_append_sheet(wb, sheetProducts, 'Categorias e Produtos');

  // --- Aba: Acompanhamentos (Grupos e Itens) ---
  const accompanimentRows = [];
  const accompanimentHeaders = [
    'Id',
    'Grupo',
    'Ordem Grupo',
    'Descrição Grupo',
    'Mínimo',
    'Máximo',
    'Item Id',
    'Item',
    'Código Item',
    'Preço Item',
    'Preço Delivery Item',
  ];
  (detailGroups || []).forEach((group) => {
    const items = group.items || [];
    if (items.length === 0) {
      accompanimentRows.push({
        'Id': group.id ?? '—',
        'Grupo': group.name ?? '—',
        'Ordem Grupo': group.order != null ? group.order : '—',
        'Descrição Grupo': group.description ?? '—',
        'Mínimo': group.min != null ? group.min : '—',
        'Máximo': group.max != null ? group.max : '—',
        'Item': '—',
        'Código Item': '—',
        'Preço Item': '—',
        'Preço Delivery Item': '—',
      });
    } else {
      items.forEach((item) => {
        accompanimentRows.push({
          'Id': group.id ?? '—',
          'Grupo': group.name ?? '—',
          'Ordem Grupo': group.order != null ? group.order : '—',
          'Descrição Grupo': group.description ?? '—',
          'Mínimo': group.min != null ? group.min : '—',
          'Máximo': group.max != null ? group.max : '—',
          'Item Id': item.id ?? '—',
          'Item': item.name ?? '—',
          'Código Item': item.code ?? '—',
          'Preço Item': formatPrice(item.price),
          'Preço Delivery Item': formatPrice(item.deliveryPrice),
        });
      });
    }
  });
  const sheetAccompaniments = XLSX.utils.json_to_sheet(
    accompanimentRows.length
      ? accompanimentRows
      : [{ 'Id': '', 'Grupo': '', 'Ordem Grupo': '', 'Descrição Grupo': '', 'Mínimo': '', 'Máximo': '', 'Item Id': '', 'Item': '', 'Código Item': '', 'Preço Item': '', 'Preço Delivery Item': '' }],
    { header: accompanimentHeaders }
  );
  XLSX.utils.book_append_sheet(wb, sheetAccompaniments, 'Acompanhamentos');

  const fullName = fileName.replace(/\.xlsx$/i, '') + '.xlsx';
  XLSX.writeFile(wb, fullName);
};
